import React, { useState, useCallback } from 'react';
import { Typography, Button, PriceBlockUs } from '@hpstellar/core/visId';
import { ImageWithPlaceholder } from '@hpstellar/core';
import { ShareFilled } from '@hpstellar/veneer-icons';
import { DEFAULT_TITLE, DEFAULT_SHAREBYEMAIL, DEFAULT_CONFIGURE_SUBTITLE } from './mobile-summary-data';
import ConsumerFinanceWidget from '../../../product/components/consumer-finance-widget';
import withPageComponents from '../../../page/components/with-page-components';
import Loader from '../sticky-header/loader';
import ShareConfig from '../share-config';
import useAddCTOToCart from '../sticky-header/useAddCTOToCart';
import { Helpers } from '../../../core/src/helpers';
import useSpecsSelected from '../configure-options/useSelectedSpecs';
import ProductIdentityDetails from '../product-identity-details';
import './mobile-summary.less';

const EMPTY_OBJ = {};

export default withPageComponents(
    ({ baseConfig = {}, device, ctoProductInitial, trackCustomMetric, shipDate }) => {
        const { title, image, ctaText } = baseConfig;
        const { buttonProps, addingToCart, price, customSaleText } = useAddCTOToCart(trackCustomMetric) || {};
        const { days } = shipDate || EMPTY_OBJ;
        const [modalOpen, setModalOpen] = useState(-1);
        const closeModal = useCallback(() => {
            setModalOpen(0);
        }, []);

        const specs = useSpecsSelected();

        if (device !== 'mobile') {
            return null;
        }

        return (
            <div className="mobile-summary">
                <Typography variant="body1" weight={700}>
                    {DEFAULT_TITLE}
                </Typography>
                <Typography variant="footnotes" weight={700} className="product-title">
                    {title}
                </Typography>
                <ProductIdentityDetails />
                <Button
                    theme="accent"
                    variation="tertiary"
                    className="share-by-email-btn"
                    onClick={() => setModalOpen(1)}
                    tabindex={0}
                >
                    {DEFAULT_SHAREBYEMAIL} <ShareFilled />
                </Button>
                {modalOpen >= 0 && <ShareConfig isOpen={modalOpen} onModalClose={closeModal} />}
                <ImageWithPlaceholder className="product-image" src={image} />
                {specs && specs.length > 0 ? (
                    <ul className="selected-config">
                        {specs.map((item, i) => (
                            <li key={i}>
                                <Typography variant="footnotes">{item}</Typography>
                            </li>
                        ))}
                    </ul>
                ) : (
                    ''
                )}
                <div className="price-block-wrapper">
                    <Typography variant="footnotes">{DEFAULT_CONFIGURE_SUBTITLE}</Typography>
                    {price && (
                        <PriceBlockUs
                            finalPrice={
                                price.salePrice
                                    ? Helpers.formatCurrency(price.salePrice)
                                    : Helpers.formatCurrency(price?.regularPrice)
                            }
                            className="price-block"
                            finalPriceTypographyVariant="subtitle"
                            oldPrice={
                                price.discountPercent && price.discountPercent > 0
                                    ? Helpers.formatCurrency(price?.regularPrice)
                                    : null
                            }
                            msrp={price?.msrp}
                            saveLabel={customSaleText}
                            slim
                        />
                    )}
                </div>
                <Loader addingToCart={addingToCart} />
                {ctaText && price && (
                    <div className="summary-cta">
                        <Button
                            {...(buttonProps || {})}
                            variation="primary"
                            fullWidth="true"
                            className="summary-cta-btn"
                            endIcon=""
                        />
                    </div>
                )}
                {days < 31 && <ConsumerFinanceWidget product={ctoProductInitial} price={price} variant="section" />}
            </div>
        );
    },
    { components: ['baseConfig', 'ctoProductInitial', 'ctoPrice', 'shipDate'], device: true }
);
